import { useQuery } from "@tanstack/react-query";

import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";

interface UseManagerUserDetailsParams {
  id: string;
  managerUserId: string;
  enabled?: boolean;
}

const useManagerUserDetails = ({ id, managerUserId, enabled }: UseManagerUserDetailsParams) => {
  const query = useQuery({
    queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGER_USER(id, managerUserId)],
    queryFn: () => AdminManagementCompaniesService.getManagerUser(id, managerUserId),
    enabled,
  });

  return query;
};

export default useManagerUserDetails;
